module.exports = __webpack_public_path__ + "img/delete.c92e3372.svg";